// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"common-BackButton__wrapper--3_Q8x","button":"common-BackButton__button--3w17f"};